import { COLLAPSE_LEFT_MENU, PIN_LEFT_MENU } from 'constants/actionTypes';

const initialState = {
    leftMenuPinned: true,
    leftMenuCollapsed: true,
};

export const leftMenuReducer = (state = initialState, action) => {
    switch(action.type) {
        case COLLAPSE_LEFT_MENU:
            return { ...state, leftMenuCollapsed: action.payload } ;
        case PIN_LEFT_MENU:
            return { ...state, leftMenuPinned: action.payload } ;
        default:
            return state;
    }
};
